import Tabs from '../../../../components/common/Tabs/Tabs';
import AlertsConfig from './AlertsConfig/AlertsConfig';
import S from './DeviceSettingsStyles';
import VideoSettingsItem from './VideoSettingsItem/VideoSettingsItem';
import AudioSchemaSettingsDeviceItem from './AudioSchemaSettingsDeviceItem/AudioSchemaSettingsDeviceItem';
import { DeviceDetails } from '../../../../API/types/Devices';
import DeviceConfiguration from '../DeviceConfiguration/DeviceConfiguration';
import DeviceCalibration from '../DeviceCalibration/DeviceCalibration';
import HWConfiguration from '../HWConfiguration/HWConfiguration';

type Props = {
  fleetId: string;
  device: DeviceDetails;
  toggleModal: (closed: boolean) => void;
};

function DeviceSettings({
  device, fleetId, toggleModal,
}: Props): JSX.Element {
  const {
    deviceId,
    isOnline,
  } = device!;
  const alertsConfigTab = (): any => (
    <AlertsConfig
      deviceId={deviceId}
      fleetId={fleetId}
      toggleModal={toggleModal}
      isOnline={isOnline}
    />
  );

  const configurationEventsContent = (): any => (
    <DeviceConfiguration toggleModal={toggleModal} deviceId={deviceId} isOnline={isOnline} />
  );

  const configurationCalibrationContent = (): any => (
    <DeviceCalibration toggleModal={toggleModal} deviceId={deviceId} isOnline={isOnline} />
  );

  const hwConfigurationContent = (): any => (
    <HWConfiguration toggleModal={toggleModal} deviceId={deviceId} isOnline={isOnline} />
  );

  const liveVideoContent = (): any => (
    <VideoSettingsItem fleetId={fleetId} toggleModal={toggleModal} isOnline={isOnline} deviceId={deviceId} />
  );

  const audioSchemaContent = (): any => (
    <AudioSchemaSettingsDeviceItem toggleModal={toggleModal} isOnline={isOnline} deviceId={deviceId} />
  );

  const tabsContent = [
    {
      label: 'Alerts',
      id: 'alerts-devices-settings',
      content: <AlertsConfig
        deviceId={deviceId}
        fleetId={fleetId}
        toggleModal={toggleModal}
        isOnline={isOnline}
      />,
    },
    // {
    //   label: 'HW Configuration (Events)',
    //   id: 'device-configuration-events',
    //   content: configurationEventsContent,
    // },
    // {
    //   label: 'HW Configuration (Calibration)',
    //   id: 'device-configuration-calibration',
    //   content: configurationCalibrationContent,
    // },
    {
      label: 'HW Configuration',
      id: 'device-configuration',
      content: <HWConfiguration toggleModal={toggleModal} deviceId={deviceId} isOnline={isOnline} />,
    },
    {
      label: 'Live Video',
      id: 'live-video-settings',
      content: <VideoSettingsItem fleetId={fleetId} toggleModal={toggleModal} isOnline={isOnline} deviceId={deviceId} />,
    },
    {
      label: 'Audio Schema',
      id: 'audio-schema-settings',
      content: <AudioSchemaSettingsDeviceItem toggleModal={toggleModal} isOnline={isOnline} deviceId={deviceId} />,
    },
  ];

  return (
    <S.Wrapper>
      <Tabs
        tabs={tabsContent}
      />
    </S.Wrapper>
  );
}

export default DeviceSettings;
